module.exports = __webpack_public_path__ + "static/media/8.120c45d9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sports/svg/8.svg
// module id = 169
// module chunks = 0